"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageKeys = void 0;
/**
 * 管理端登录相关存储 key（统一命名）
 */
var StorageKeys = exports.StorageKeys = {
  /** sessionStorage：访问令牌 */
  ACCESS_TOKEN: 'access_token',
  /** sessionStorage：登录用户快照 */
  ADMIN_USER: 'admin_user',
  /** Cookie：短信平台是否已登录 */
  ADMIN_SMS_LOGIN: 'admin_sms_login',
  /** localStorage：OAuth 回调 code */
  ADMIN_OAUTH_CODE: 'admin_oauth_code',
  /** localStorage：登录滑块风控状态 */
  LOGIN_SLIDER_STATE: 'login_slider_state',
  /** localStorage：设备指纹（API 签名） */
  ADMIN_DEVICE_ID: 'admin_device_id'
};